<template>
  <v-footer class="py-0" app>
    <v-container>
      <v-row>
        <v-col cols="12" md="10" offset-md="1">
          <v-row>
            <v-col
              cols="12"
              md="9"
              lg="8"
              class="d-flex flex-wrap justify-center justify-md-start"
            >
              <div class="text-center">
                <v-dialog v-model="dialog" scrollable width="53%">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="secondary"
                      text
                      rounded
                      v-bind="attrs"
                      v-on="on"
                      @click="getTermsConditions()"
                      >{{ $t('portal.general.footer.labels.terms_link') }}
                    </v-btn>
                  </template>

                  <v-card :loading="loading">
                    <v-app-bar flat color="white">
                      <v-card-title>{{
                        $t('portal.general.footer.labels.terms_link')
                      }}</v-card-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-app-bar>
                    <v-divider></v-divider>
                    <v-card-text v-if="alert">
                      <v-alert
                        v-model="alert"
                        close-icon="mdi-close"
                        dark
                        transition="fade-transition"
                        color="primary ma-9"
                        type="error"
                      >
                        <div class="white--text font-weight-bold mb-0">
                          {{ $t('portal.login.login.alerts.title') }}:
                          {{ $t('portal.login.login.alerts.accessing_as_user_monitoring') }}
                        </div>
                        <div class="white--text mb-0">{{ alertMessage }}</div>
                      </v-alert>
                    </v-card-text>
                    <v-card-text
                      class="terminos_and_conditions"
                      v-html="termsConditionHtml"
                    ></v-card-text>
                  </v-card>
                </v-dialog>
              </div>
            </v-col>

            <v-col
              cols="12"
              sm="6"
              offset-sm="3"
              offset-md="0"
              md="3"
              lg="4"
              class="copyright d-flex justify-center justify-md-end secondary--text text-right align-center"
            >
              <span>{{ $t('portal.general.footer.labels.developed_by') }}</span>
              <a href="https://strix.com.ar">
                <SvgLogo iconType="StrixLogo" width="70" class="ml-2" />
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { SvgLogo } from '@leapsight/styleguide'
import { TermsConditionsHelpers } from '@/helpers/mainExports'

export default {
  name: 'Footer',
  components: {
    SvgLogo
  },
  props: {
    connection: Object
  },
  data() {
    return {
      dialog: false,
      termsConditionHtml: '',
      loading: false,
      alert: false,
      alertMessage: ''
    }
  },
  methods: {
    async getTermsConditions() {
      try {
        this.loading = true
        const {
          terms_and_conditions: termsAndCondition
        } = await TermsConditionsHelpers.accountInformationFetch(this.connection)

        const lastVersionAccepted = this.saveLastVersionAccepted(
          termsAndCondition
        )

        this.termsConditionHtml = await TermsConditionsHelpers.checkVersionTermsConditions(
          this.connection,
          lastVersionAccepted
        )
        this.loading = false
      } catch (e) {
        this.alert = true
        const { kwargs } = e
        this.alertMessage =
          kwargs.message ?? 'La plantilla no se ha encontrado.'
        this.loading = false
      }
    },

    saveLastVersionAccepted(termsAndConditionAccepted) {
      let lastVersionDateAcepted = 0
      let lastVersionAccepted = ''
      Object.entries(termsAndConditionAccepted).map(([key, value]) => {
        if (lastVersionDateAcepted < value.acceptance_timestamp) {
          lastVersionDateAcepted = value.acceptance_timestamp
          lastVersionAccepted = key
        }
      })
      return lastVersionAccepted
    }
  }
}
</script>

<style lang="scss" scoped>
.v-footer--absolute {
  z-index: 999;
}
.copyright {
  span {
    font-size: 0.75rem;
  }
}

@media (min-width: 600px) {
  .terminos_and_conditions div {
    width: initial !important;
    margin-bottom: 0px !important;
    margin-top: 35pt;
    margin-left: 85pt;
    margin-right: 85pt;
  }
}
@media (max-width: 600px) {
  .terminos_and_conditions div {
    width: 100% !important;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
}
</style>
